const React = require('react')
const { useNetworkConfig } = require('@contexts')
const { CustomDropdown } = require('@components')
const { useHistory } = require('react-router-dom')
const { NETWORK_CONFIG } = require('@configs')

require('@styles/layouts/header/dropdownNetworks.header.css')

const HeaderDropdownNetworks = props => {
    const { network } = useNetworkConfig()
    const history = useHistory()

    const networkOptions = [
        {
            value: NETWORK_CONFIG.agd.shortName,
            name: NETWORK_CONFIG.agd.name,
            iconUrl: NETWORK_CONFIG.agd.networkIcon
        },
        {
            value: NETWORK_CONFIG.hg.shortName,
            name: NETWORK_CONFIG.hg.name,
            iconUrl: NETWORK_CONFIG.hg.networkIcon
        },
        {
            value: NETWORK_CONFIG.vibi.shortName,
            name: NETWORK_CONFIG.vibi.name,
            iconUrl: NETWORK_CONFIG.vibi.networkIcon
        },
        {
            value: NETWORK_CONFIG.vibi2.shortName,
            name: NETWORK_CONFIG.vibi2.name,
            iconUrl: NETWORK_CONFIG.vibi2.networkIcon
        },
        { type: 'divider' },
        {
            value: NETWORK_CONFIG.mbc.shortName,
            name: NETWORK_CONFIG.mbc.name,
            iconUrl: NETWORK_CONFIG.mbc.networkIcon
        }
    ]

    return (
        <div className='header-networks-dropdown'>
            <CustomDropdown
                listItems={networkOptions}
                currentItem={{
                    iconPath: network.data.networkIcon,
                    title: network.data.name
                }}
                handleClick={value => {
                    history.push(`/${value}`)
                    window.location.reload()
                }}
            />
        </div>
    )
}

module.exports = { HeaderDropdownNetworks }
